// extracted by mini-css-extract-plugin
export default {"buttonMenuMoreWrap":"ButtonMenuMore_buttonMenuMoreWrap__mQ8Mh","menu":"ButtonMenuMore_menu__maw0d","badge":"ButtonMenuMore_badge__IlRje"};